import { render } from "./JobView.vue?vue&type=template&id=2951d989&scoped=true"
import script from "./JobView.vue?vue&type=script&lang=js"
export * from "./JobView.vue?vue&type=script&lang=js"

import "./JobView.vue?vue&type=style&index=0&id=2951d989&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2951d989"]])

export default __exports__